<div class="grid grid-nogutter m-0 p-0 relative overlay-gallery"
     [class.overlay-gallery--has-previous-post]="hasPreviousPost"
     [class.overlay-gallery--has-next-post]="canNavigateNextPost">
  <div style="background-color: black"
       class="col-12 swiper-fixed-col relative height-100 m-0 p-0">
    <div class="media-stage"
         [style.height.px]="mediaStageHeight"
         [style.transform]="'translateY(' + mediaTranslateY + 'px) scale(' + mediaScale + ')'">
      <swiper
        *ngIf="loaded"
        #postSwiper
        class="overlay-gallery-post-swiper"
        [config]="postConfig"
        [virtual]="postConfig.virtual"
        [initialSlide]="activePostIndex"
        (slideChange)="onPostSlideChange($event)"
        (reachEnd)="onPostReachEnd()"
        (touchEnd)="onPostTouchEnd($event)"
        [allowSlideNext]="canNavigateNextPost"
        [allowSlidePrev]="hasPreviousPost"
      >
        <ng-template swiperSlide *ngFor="let postItem of posts; let postIndex = index" [virtualIndex]="postIndex">
          <swiper
            *ngIf="isPostSlideMounted(postIndex)"
            #swiperComponent
            class="overlay-gallery-media-swiper"
            [config]="config"
            [initialSlide]="getMediaIndex(postIndex)"
            (swiper)="onSwiper($event, postIndex)"
            (slideChange)="onSlideChange($event, postIndex)"
            (navigationNext)="onNavigationNext($event)"
            (activeIndexChange)="onActiveIndexChange($event, postIndex)"
            [allowSlideNext]="true"
            [allowSlidePrev]="true"
            [slidesPerView]="1"
            [preloadImages]="true"
            [navigation]="windowWidth > 960"
          >
            <ng-template swiperSlide *ngFor="let item of getVisibleMedia(postItem); let i = index">
              <app-media-view [mediaObject]="item" [prefix]="item.type === MediaTypeEnum.VIDEO ? 'video-preview': 'image-preview'" [id]="item.id" (click)="toggleVideoPlay()"
                              [currentTime]="getSlideCurrentTime(postIndex, i)" (currentTimeChange)="onSlideCurrentTimeChange($event, postIndex, i)" [contain]="true" [ratio]="0" [isInLightBoxContext]="true"
                              [prewarm]="false"
                              [videoDecoderMode]="getVideoDecoderMode(postIndex, i)"
                              [videoResourceKey]="getVideoResourceKey(postIndex, i)"
                              [videoResourceScope]="videoResourceScope"
                              [viewportDecoderHandoff]="getViewportDecoderHandoff(postIndex, i)"
                              (videoLoadingChange)="onVideoLoadingChange($event, postIndex, i)"
                              (lightboxPlayerReady)="onLightboxPlayerReady(postIndex, i)">
              </app-media-view>
            </ng-template>
          </swiper>
        </ng-template>
        <ng-template swiperSlide *ngIf="isLoadingNextPostPage">
          <div class="overlay-gallery-loading-slide" aria-live="polite">
            <p-skeleton width="56%" height="72%"></p-skeleton>
            <p-skeleton width="12rem" height="1rem"></p-skeleton>
          </div>
        </ng-template>
      </swiper>
      <div *ngIf="isActiveVideoLoading" class="overlay-gallery-video-loading" role="status" aria-live="polite">
        <span class="overlay-gallery-video-loading__spinner" aria-hidden="true"></span>
      </div>
    </div>
    <div class="overlay-gallery-post-navigation" *ngIf="windowWidth >= 768 && (posts.length > 1 || canNavigateNextPost)">
      <button
        *ngIf="hasPreviousPost"
        pButton
        type="button"
        class="p-button-rounded p-button-text overlay-gallery-post-navigation__previous"
        icon="pi pi-chevron-up"
        [attr.aria-label]="'features.overlay_gallery.previous_post' | translate"
        (click)="previousPost()"
      ></button>
      <button
        *ngIf="canNavigateNextPost"
        pButton
        type="button"
        class="p-button-rounded p-button-text overlay-gallery-post-navigation__next"
        icon="pi pi-chevron-down"
        [attr.aria-label]="'features.overlay_gallery.next_post' | translate"
        (click)="nextPost()"
      ></button>
    </div>
    <div class="flex flex-column overlay-gallery-buttons">
      <app-speed-dial #tileSpeedDial [model]="reactionService.items" direction="up"></app-speed-dial>
      <ngx-emoji class="additional-emoji" *ngIf="post.currentUserReaction" [emoji]="post.currentUserReaction.reactedWith|reactionClassMap" size="14"></ngx-emoji>
      <button pButton [size]="'large'" [text]="true" [rounded]="true"
              [ngClass]="{'p-highlight': !post.currentUserReaction, 'p-button-primary': post.currentUserReaction}"
              [icon]="!post.currentUserReaction ? 'pi pi-heart': 'pi pi-heart-fill'"
              ngxLongPress2
              (onLongPress)="reactionService.toggleReactionBtn($event, post, ReactionTypeEnum.POST_REACTION, tileSpeedDial)"
              (click)="reactionService.toggleThumbsUp($event, post, ReactionTypeEnum.POST_REACTION, tileSpeedDial)"
              (contextmenu)="false"
      >
      </button>
      <button pButton [size]="'large'" [text]="true" [icon]="'pi pi-comment'" class="p-highlight" [rounded]="true"
              (click)="openComments()"
      ></button>
      <button pButton [size]="'large'" [text]="true" [icon]="'pi pi-qrcode'" class="p-highlight" [rounded]="true"
              (click)="openQrDialog()"
      ></button>
    </div>
    <div class="volume" *ngIf="(vs.muted$ | async) !== null">
      <button (click)="getActiveMediaView()?.toggleVolume($event)" pButton pRipple *ngIf="vs.muted$ | async" icon="fa fa-volume-high"
              class="p-button-rounded p-button-default p-button-text"></button>
      <button (click)="getActiveMediaView()?.toggleVolume($event)" pButton pRipple *ngIf="!(vs.muted$ | async)" icon="fa fa-volume-xmark"
              class="p-button-rounded p-button-default p-button-text"></button>
    </div>

    <div class="overlay-gallery-mobile-caption"
         *ngIf="windowWidth < 768 && post?.content?.trim()?.length"
         [class.overlay-gallery-mobile-caption--expanded]="isDescriptionExpanded">
      <div #mobileCaptionText class="overlay-gallery-mobile-caption__text"
           [class.overlay-gallery-mobile-caption__text--expanded]="isDescriptionExpanded">
        <span [innerHTML]="post.content | sanitizeHtml"></span>
      </div>
      <button
        *ngIf="showDescriptionToggle"
        pButton
        type="button"
        class="p-button-sm p-button-text overlay-gallery-mobile-caption__toggle"
        (click)="toggleDescriptionExpanded()">
        {{ (isDescriptionExpanded ? 'common.less' : 'common.more') | translate }}
      </button>
    </div>
  </div>

  <div class="col-12 social-fixed-col z-1 absolute top-0 right-0 md:col-fixed m-0 p-0">
    <div class="grid grid-nogutter width-100">
      <div class="col p-2 flex column-gap-2">
        <a *ngIf="post.postedBy?.slug; else overlayPostedByAvatar" [routerLink]="['/' + post.postedBy.slug, 'garage']" (click)="close()">
          <app-thumbnail
            classList="thumbnail-inline-block"
            size="md"
            [circle]="true"
            [imgSrc]="post.postedBy.avatar | mediaObject"
          ></app-thumbnail>
        </a>
        <ng-template #overlayPostedByAvatar>
          <app-thumbnail
            classList="thumbnail-inline-block"
            size="md"
            [circle]="true"
            [imgSrc]="post.postedBy?.avatar | mediaObject"
          ></app-thumbnail>
        </ng-template>
        <div>
          <a *ngIf="post.postedBy?.slug; else overlayPostedByName" (click)="close()" [routerLink]="['/' + post.postedBy.slug, 'garage']">{{post.postedBy.username}}</a>
          <ng-template #overlayPostedByName>
            <span>{{ post.postedBy?.username }}</span>
          </ng-template>
          <span class="date block">{{post.createdAt | dateAgo}}</span>
        </div>
        <div>
          <ng-container [ngSwitch]="post.type">
            <ng-container *ngSwitchCase="PostTypeEnum.PROJECT_POST">
              <a *ngIf="post.project; else overlayProjectPostLabel" (click)="close()" [routerLink]="post.postedBy?.slug ? ['/' + post.postedBy.slug, 'garage', post.project.slug] : ['/garage', post.project.slug]">
                <i class="pi pi-caret-right pr-1"></i>
                <i class="pi pi-car pr-1"></i>
                <ng-container *ngIf="post.project.alias && post.project.vehicle?.fullVehicleIdentity">{{post.project.alias}} | </ng-container>
                {{projectTargetLabel|truncateOnWord: 50: '...'}}</a>
              <ng-template #overlayProjectPostLabel>
                <span>
                  <i class="pi pi-caret-right pr-1"></i>
                  <i class="pi pi-car pr-1"></i>
                  <ng-container *ngIf="post.project.alias && post.project.vehicle?.fullVehicleIdentity">{{post.project.alias}} | </ng-container>
                  {{projectTargetLabel|truncateOnWord: 50: '...'}}
                </span>
              </ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="PostTypeEnum.PROJECT_MEDIA_POST">
              <a *ngIf="post.project; else overlayProjectMediaPostLabel" (click)="close()" [routerLink]="post.postedBy?.slug ? ['/' + post.postedBy.slug, 'garage', post.project.slug] : ['/garage', post.project.slug]">
                <i class="pi pi-caret-right pr-1"></i>
                <i class="pi pi-image pr-1"></i>
                <ng-container *ngIf="post.project.alias && post.project.vehicle?.fullVehicleIdentity">{{post.project.alias}} | </ng-container>
                {{projectTargetLabel|truncateOnWord: 50: '...'}}</a>
              <ng-template #overlayProjectMediaPostLabel>
                <span>
                  <i class="pi pi-caret-right pr-1"></i>
                  <i class="pi pi-image pr-1"></i>
                  <ng-container *ngIf="post.project.alias && post.project.vehicle?.fullVehicleIdentity">{{post.project.alias}} | </ng-container>
                  {{projectTargetLabel|truncateOnWord: 50: '...'}}
                </span>
              </ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="PostTypeEnum.EVENT_DISCUSSION_POST">
              <a (click)="close()" [routerLink]="['/events', post.event.slug, EventShowTabsEnum.DISCUSSION]">
                <i class="pi pi-caret-right pr-1"></i>
                <i class="pi pi-calendar-plus pr-1"></i>
                {{post.event.name}}</a>
            </ng-container>
            <ng-container *ngSwitchCase="PostTypeEnum.SIMPLE_POST">
              <a *ngIf="post.postedBy?.slug; else overlaySimplePostLabel" (click)="close()" [routerLink]="['/' + post.postedBy.slug, 'profile']">
                <i class="pi pi-caret-right pr-1"></i>
                <i class="pi pi-user pr-1"></i>
                {{post.postedBy.username}}</a>
              <ng-template #overlaySimplePostLabel>
                <span>
                  <i class="pi pi-caret-right pr-1"></i>
                  <i class="pi pi-user pr-1"></i>
                  {{post.postedBy?.username}}
                </span>
              </ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="PostTypeEnum.COLLABORATION_MEDIA_POST">
              <a
                (click)="close()"
                [routerLink]="['/', post.collaboration?.owner?.slug || post.postedBy.slug, 'collaborations', post.collaboration?.slug || post.collaboration?.id]">
                <i class="pi pi-caret-right pr-1"></i>
                <i class="pi pi-images pr-1"></i>
                {{ post.collaboration?.title || (collaborationProjectTargetLabel | truncateOnWord: 50: '...') }}
              </a>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="col-fixed flex justify-content-end">
        <button
          (click)="close()"
          pButton
          icon="pi pi-times"
          class="p-button-rounded p-button-plain p-button-text"
        ></button>
        <!--        <app-end-cap-->
        <!--          *ngxPermissionsOnly="[ post.postedBy | ownerRole]"-->
        <!--          icon="pi pi-ellipsis-h"-->
        <!--          [pointerClass]="'p-button-rounded p-button-text p-button-icon-only p-button-primary'"-->
        <!--          (onClickTrigger)="emitPostContextMenuOpen(post)"-->
        <!--        >-->
        <!--        </app-end-cap>-->
      </div>
      <div class="col-12 px-2">
        <div class="overlay-gallery-desktop-description" *ngIf="windowWidth > 768 && post?.content?.trim()?.length">
          <div #desktopCaptionText class="overlay-gallery-desktop-description__text"
               [class.overlay-gallery-desktop-description__text--expanded]="isDescriptionExpanded">
            <span [innerHTML]="post.content | sanitizeHtml"></span>
          </div>
          <button
            *ngIf="showDescriptionToggle"
            pButton
            type="button"
            class="p-button-sm p-button-text overlay-gallery-desktop-description__toggle"
            (click)="toggleDescriptionExpanded()">
            {{ (isDescriptionExpanded ? 'common.less' : 'common.more') | translate }}
          </button>
        </div>
        <app-social-actions
          *ngIf="windowWidth > 768 && socialActionsActivated"
          [currentUser]="currentUser"
          [post]="post"
          [preloadedComments]="true"
          [socialModalDisabled]="true"
        ></app-social-actions>
      </div>
    </div>
  </div>
</div>
<app-qr-dialog [(visible)]="qrDialogVisible" [data]="qrDialogData"></app-qr-dialog>
<app-bottom-sheet
  #bottomSheetComponent
  (dragProgressChange)="onBottomSheetDragProgress($event)"
  (dragMetricsChange)="onBottomSheetDragMetrics($event)"
>
  <ng-container *ngIf="bottomSheetComponent|bottomSheetAvailable: windowWidth < 768">
    <div class="px-2 pt-2 mobile-social-sheet-content">
      <app-social-actions
        *ngIf="socialActionsActivated"
        [currentUser]="currentUser"
        [post]="post"
        [preloadedComments]="true"
        [socialModalDisabled]="true"
        (threadListUnfolded)="onUnfoldedThreadList($event, bottomSheetComponent)"
      ></app-social-actions>
    </div>
  </ng-container>
</app-bottom-sheet>
